import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { api, idr, fmtDate, API } from "@/lib/api";
import { CheckCircle2, Download, Home, XCircle } from "lucide-react";

export default function RegisterSuccess() {
  const { regNo } = useParams();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [r, setR] = useState(null);
  useEffect(() => {
    api.get(`/registrations/lookup/${regNo}`, { params: { token } })
      .then(res => setR(res.data))
      .catch(() => setR(false));
  }, [regNo, token]);
  if (r === false) return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-24 text-center">
      <XCircle className="w-14 h-14 text-red-500 mx-auto mb-4" />
      <h1 className="font-display text-2xl font-extrabold text-emerald-950">Pendaftaran Tidak Ditemukan</h1>
      <p className="mt-2 text-slate-600">Tautan tidak valid atau data pendaftaran tidak ditemukan.</p>
      <Link to="/" className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-emerald-950 text-white font-bold text-sm"><Home className="w-4 h-4" /> Kembali ke Beranda</Link>
    </div>
  );
  if (!r) return <div className="p-16 text-center text-slate-500">Memuat...</div>;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
      <div className="text-center">
        <div className="mx-auto w-20 h-20 rounded-full bg-emerald-100 flex items-center justify-center mb-6"><CheckCircle2 className="w-12 h-12 text-emerald-700" /></div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-emerald-950">Pendaftaran Berhasil</h1>
        <p className="mt-3 text-slate-600">Data Anda sedang menunggu proses verifikasi oleh admin LSP. Simpan nomor pendaftaran dan tautan ini.</p>
      </div>
      <div className="mt-10 bg-white rounded-2xl border border-slate-100 p-8" data-testid="success-details">
        <dl className="grid sm:grid-cols-2 gap-6 text-sm">
          <div><dt className="text-xs uppercase tracking-widest text-slate-500 font-bold">Nomor Pendaftaran</dt><dd className="mt-1 font-mono text-emerald-950 font-bold text-lg">{r.registration_number}</dd></div>
          <div><dt className="text-xs uppercase tracking-widest text-slate-500 font-bold">Nama Peserta</dt><dd className="mt-1 text-emerald-950">{r.personal?.full_name}</dd></div>
          <div className="sm:col-span-2"><dt className="text-xs uppercase tracking-widest text-slate-500 font-bold">Skema</dt><dd className="mt-1 text-emerald-950">{r.certification?.scheme_title}</dd></div>
          <div><dt className="text-xs uppercase tracking-widest text-slate-500 font-bold">Tanggal Pendaftaran</dt><dd className="mt-1 text-emerald-950">{fmtDate(r.created_at)}</dd></div>
          <div><dt className="text-xs uppercase tracking-widest text-slate-500 font-bold">Status</dt><dd className="mt-1"><span className="inline-block px-2.5 py-1 rounded-md bg-amber-100 text-amber-800 text-xs font-bold">{r.status}</span></dd></div>
          <div><dt className="text-xs uppercase tracking-widest text-slate-500 font-bold">Biaya</dt><dd className="mt-1 text-emerald-950 font-bold">{idr(1000000)}</dd></div>
          <div><dt className="text-xs uppercase tracking-widest text-slate-500 font-bold">Status Pembayaran</dt><dd className="mt-1"><span className="inline-block px-2.5 py-1 rounded-md bg-slate-100 text-slate-800 text-xs font-bold">{r.payment_status}</span></dd></div>
        </dl>
      </div>
      <div className="mt-6 flex flex-col sm:flex-row gap-3">
        <a href={`${API}/registrations/${r.id}/pdf?token=${encodeURIComponent(token || "")}`} target="_blank" rel="noreferrer" data-testid="download-pdf-btn" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg gold-gradient text-emerald-950 font-bold text-sm">
          <Download className="w-4 h-4" /> Download Formulir FR.APL.01
        </a>
        <Link to="/" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg border-2 border-slate-200 text-slate-700 font-bold text-sm hover:bg-slate-50">
          <Home className="w-4 h-4" /> Kembali ke Beranda
        </Link>
      </div>
    </div>
  );
}
